import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.button.attrs({ className: 'ui__button' })`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.button};
  ${(props) => `
    display: ${props.block ? 'block' : 'inline-block'};
    width: ${props.block ? '100%' : 'initial'};
    background: ${props.theme.colours.primary};
    padding: ${props.theme.whitespace.xs} ${props.theme.whitespace.small};
    border: ${props.theme.borders.width} solid ${props.theme.colours.primary};
    border-radius: ${props.theme.borders.radius};
  `};
  text-align: center;
  color: white;
  font-weight: 300;
  cursor: pointer;
  outline: none;
  a {
    color: white !important;
    text-decoration: none !important;
  }
  &:hover,
  &:focus {
    border: ${(props) => `${props.theme.borders.width} solid ${props.theme.colours.dark}`};
    background-color: ${(props) => props.theme.colours.dark};
  }
`;

const Button = ({ children, onClick, block, ...props }) => (
  <Container
    onClick={(e) => onClick(e)}
    role="button"
    tabIndex={0}
    block={block}
    {...props}
  >
    {children}
  </Container>
);
Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  block: PropTypes.bool
};
Button.defaultProps = {
  onClick: () => {},
  block: false
};

export default Button;
